/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'ui-components/Input'
import { Select } from './styles'

export default function SelectForm(props) {
  const {
    disabled,
    value,
    label,
    ...rest
  } = props

  const renderSelect = () => {
    if (disabled) {
      return (
        <Input value={value.label} disabled label={label} />
      )
    }

    return (
      <Select {...rest} value={value} label={label} />
    )
  }

  return renderSelect()
}

SelectForm.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  label: PropTypes.string,
}

SelectForm.defaultProps = {
  disabled: false,
  label: '',
}
